<template>
  <a
    :href="authType == 2 && !userInfo ? `/login.html` : courseData.course_url"
    target="_blank"
    class="course-card"
  >
    <div class="course">
      <div class="top">
        <div class="course-img">
          <img
            :src="
              courseData.course_cover_url ||
              require('@/assets/images/common/course_cover.png')
            "
          />
        </div>
        <div class="course-name text-overflow" title="courseData.course_name">
          {{ courseData.course_name }}
        </div>
      </div>
      <div class="bottom">
        <div class="course-teacher text-overflow">
          {{ courseData.lecturer }} <span v-show="courseData.lecturer && courseData.organ_name">|</span>
          {{ courseData.organ_name }}
        </div>
        <div class="course-mes">
          <div>
            累计选课
            <span class="unit">{{ courseData.students_num || 0 }}</span> 人
          </div>
          <div
          >
            <span class="course-mescredit"
              >学分
              <span class="num">{{ courseData.credit || 0 }}</span></span
            >
            <span class="course-line"></span>
            <span class="course-meshour"
              >学时
              <span class="num">{{ courseData.hours || 0 }}</span></span
            >
          </div>
        </div>
      </div>
    </div>
  </a>
</template>
<script>
import { defineComponent, reactive } from "vue";

export default defineComponent({
  setup() {
    const css = reactive({ testColor: "green" });
    return {
      ...css,
    };
  },
  props: {
    courseData: {
      required: true,
      type: Object,
    },
    showLabel: {
      required: false,
      type: Boolean,
      default: false,
    },
    labelContent: {
      required: false,
      type: String,
      default: "course_type_name",
    },
    cols: {
      required: false,
      type: String,
      default: "n + 3",
    },
    userInfo: {
      type: Object,
      default: null
    },
    authType: Number
  },
  created() {
    // this.getAuth()
  },
  data() {
    return {
      // authType: 0
      // authType: JSON.parse(sessionStorage.getItem('authInfo')).filter(item => item.code == '10401')[0].auth_type
    }
  },
  watch: {
    authType: {
      handler(val) {
        // this.getCourseUrl()
      },
      deep: true
    }
  },
  methods: {
    // getCourseUrl() {
    //   if (this.authType == 2 && !this.userInfo) {
    //     this.courseData.course_url = `/login.html`
    //     return
    //   }
    // },
    // async getAuth() {
    //   const res2 = await this.$http.getConfigList()
    //   this.authType = res2.filter(item => item.code == '10401')[0].auth_type
    // }
  }
});
</script>
<style lang="scss" scoped>
$color: #0C53A2;
.course-card {
  display: block;
  margin-top: 16px;
  margin-right: 20px;
  width: 284px;
  height: 300px;
  background-color: #fff;
  cursor: pointer;
  border: 1px solid #ededee;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  &:hover {
    border-color: $color;
    box-shadow: 0 4px 4px 0px rgba($color: #000000, $alpha: 0.1);
  }
  .course {
    width: 100%;
    height: 100%;
    .course-img {
      height: 161px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .course-name {
      margin-top: 14px;
      padding: 0 20px;
      font-size: 16px;
      color: #34373f;
      &:hover {
        color: $--hover-theme-color;
      }
    }
    .bottom {
      margin-top: 8px;
      font-size: 12px;
      padding: 0 20px;
      color: #999;
      .course-teacher {
        height: 17px;
        font-family: PingFangSC-Regular, PingFang SC;
        line-height: 17px;
      }
      .course-mes {
        display: flex;
        margin-top: 40px;
        align-items: center;
        justify-content: space-between;
        .unit {
          margin-top: 40px;
          color: $--color-primary;
        }
      }
    }
  }
}

.course-card:nth-of-type() {
  margin-left: 21px;
}

.course-card 
.text-overflow {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.course-mescredit {
  margin-left: 12px;
  .num {
    color: $--color-primary;
  }
}  
.course-mes .course-meshour {
  // margin-right: 15px;
  margin-left: 10px;
  .num {
    color: $--color-primary;
  }
}
</style>